"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------

/** OutLink */


var OutLink = function OutLink(props) {
  return /*#__PURE__*/_react["default"].createElement("a", {
    href: props.to,
    target: "_blank",
    rel: "noopener noreferrer",
    alt: props.to,
    style: props.style,
    className: props.className
  }, props.children);
};

OutLink.propTypes = process.env.NODE_ENV !== "production" ? {
  to: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  style: _propTypes["default"].object,
  // eslint-disable-line
  className: _propTypes["default"].string,
  // eslint-disable-line
  classes: _propTypes["default"].object // eslint-disable-line react/forbid-prop-types, react/no-unused-prop-types

} : {};
OutLink.defaultProps = {
  style: {}
}; // ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Export
// ----------------------------------------------------------------------------

var _default = OutLink;
exports["default"] = _default;
module.exports = exports.default;